import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpService } from '../http/http.service';
import { AppConfig } from '@boels/models';

@Injectable()
export class I18nHttpLoaderService implements TranslocoLoader {
  private http = inject(HttpService);
  private environment = inject<AppConfig>('ENVIRONMENT' as any);

  getTranslation(lang: string) {
    return this.http.get<Translation>(
      `${this.environment.baseUrl}assets/i18n/${lang}.json`,
    );
  }
}
